'use strict';

import React from 'react';
import {Link,browserHistory} from 'react-router';
// import LazyLoad from 'react-lazy-load';
import ImageWithSpanner from './ImageWithSpanner';

require('styles/MediaArticle.scss');

class MediaArticleComponent extends React.Component {

  render(){
  	let {media,index} = this.props;
		let {format_desc,images,author} = media;
  	let format_desc_array = format_desc?format_desc.split('\n'):[];
		let imgs = images?images.origin:[];

  	let descs = format_desc_array.map((desc,index) => {
			if(desc){
				return (
				<div key={index} className='block'>
					<div className="desc">
						{desc}
					</div>
					{imgs&&imgs[index+1]?(
						<div className="image">
							{/* <div className="overlay"></div> */}
							{/* <LazyLoad className="responsive" throttle={50} debounce={true} > */}
								{/* <img onClick={this.props.showPic.bind(this,imgs[index+1])} src={imgs[index+1]}/> */}
							{/* </LazyLoad> */}
								<ImageWithSpanner onClick={this.props.showPic.bind(this,imgs[index+1])} imageUrl={imgs[index+1]}/>
						</div>
					):''}
				</div>
				)
			} else {
				if(imgs && imgs[index + 1]){
					return (
						<div key={index} className="block">
							<div className="image">
								{/* <div className="overlay"></div> */}
								{/* <LazyLoad className="responsive" throttle={50} debounce={true} > */}
									{/* <img  onClick={this.props.showPic.bind(this,imgs[index+1])} src={imgs[index+1]}/> */}
								{/* </LazyLoad> */}
								<ImageWithSpanner onClick={this.props.showPic.bind(this,imgs[index+1])} imageUrl={imgs[index+1]}/>
							</div>
						</div>
					)
				}else{
					return undefined;
				}
			}
  	});

	let moreImgs;

	if(imgs){
		let temp_imgs = imgs.concat();
		let moreImages = temp_imgs.splice(format_desc_array.length + 1,imgs.length);
			
	  moreImgs = moreImages.map((img,index) => {
			return (
				<div className="image" key={index}>
					{/* <div className="overlay"></div> */}
					{/* <LazyLoad className="responsive" throttle={50} debounce={true}> */}
						{/* <img onClick={this.props.showPic.bind(this,moreImages[index])} src={moreImages[index]} /> */}
					{/* </LazyLoad> */}
						<ImageWithSpanner onClick={this.props.showPic.bind(this,moreImages[index])} imageUrl={moreImages[index]}/>
				</div>
			);
		});
	}

	let nameReveal;
	if(media.name){
	  nameReveal = (
			<div className="name">{media.name}</div>
	  );
	}

	let addressReveal;
	if(media.formatted_address){
	  addressReveal = (
	  	<div className="address-info">
				<div className="address-tag">地址:</div>
				<div className="address">{media.formatted_address}</div>
			</div>
	  );
	}

	let hiddenReveal;
	if(media.has_hidden){
 	  hiddenReveal = (
		<div className="hidden-info">
		  <div className="hidden-tag">隐藏信息:</div>
		  <div className="hidden-desc">
		  	{media.hidden_desc}
		  </div>
		  <div className="hidden-tag mt-20">隐藏链接:</div>
		  <div className="hidden-url">
		  	<a href={media.hidden_url}>点击跳转</a>
		  </div>
		</div>
 	  );
	}

	return (
	  <div className="media-article-component">
	  	<div className="separator"></div>
	  	<div className="index">{index+1}</div>
	  	<div className="media">
	  	  {nameReveal}
				{(imgs&&imgs.length)?(
					<div className="image">
						{/* <img onClick={this.props.showPic.bind(this,imgs[0])} src={imgs[0]} /> */}
						<ImageWithSpanner onClick={this.props.showPic.bind(this,imgs[0])} imageUrl={imgs[0]} />
					</div>
				):''}
				{descs}
				{moreImgs}
				{addressReveal}
	  	</div>
	  	{hiddenReveal}
	  	<div className="detail">
	  	  <div className="hidden-tag">
	  	    <Link to={`/media/${media._id}`}> 查看详情 </Link>
	  	  </div>
	  	  <div className="author">
	  	  	探索者：{author.name}
	  	  </div>
	  	</div>
	  </div>
	);
  }
}

MediaArticleComponent.displayName = 'MediaArticleComponent';

export default MediaArticleComponent;



// WEBPACK FOOTER //
// ./src/components/MediaArticleComponent.js